import React from 'react';
export function TermsOfService() {
  return <div className="prose prose-sm max-w-none text-[#5C4A3A]/80" data-id="element-96">
      <p className="text-base leading-relaxed mb-4" data-id="element-97">
        <strong className="text-[#5C4A3A]" data-id="element-98">Última actualización:</strong>{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <section className="mb-6" data-id="element-99">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-100">
          1. Aceptación de los Términos
        </h3>
        <p className="mb-3" data-id="element-101">
          Al adquirir "Transforma tu Vida: Un Nuevo Comienzo", aceptas estos
          Términos de Servicio en su totalidad. Si no estás de acuerdo con
          alguna parte de estos términos, no debes realizar la compra.
        </p>
      </section>

      <section className="mb-6" data-id="element-102">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-103">
          2. Descripción del Producto
        </h3>
        <p className="mb-3" data-id="element-104">
          "Transforma tu Vida: Un Nuevo Comienzo" es un producto digital en
          formato PDF de 49 páginas. Es una guía de autoayuda diseñada para
          mujeres que buscan establecer límites saludables, cerrar ciclos
          emocionales y recuperar su bienestar.
        </p>
        <p className="mb-3" data-id="element-105">
          <strong className="text-[#5C4A3A]" data-id="element-106">Importante:</strong> Este producto
          es una guía de desarrollo personal y no sustituye el asesoramiento
          profesional de un terapeuta, psicólogo o médico.
        </p>
      </section>

      <section className="mb-6" data-id="element-107">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-108">
          3. Precio y Pago
        </h3>
        <p className="mb-3" data-id="element-109">
          El precio actual del producto es{' '}
          <strong className="text-[#E8A87C]" data-id="element-110">US$6.39</strong> (68% de descuento
          sobre el precio regular de US$19.97).
        </p>
        <p className="mb-3" data-id="element-111">
          El pago se procesa de forma segura a través de nuestro procesador de
          pagos. Aceptamos las principales tarjetas de crédito y débito.
        </p>
      </section>

      <section className="mb-6" data-id="element-112">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-113">
          4. Entrega del Producto
        </h3>
        <p className="mb-3" data-id="element-114">Tras completar tu compra, recibirás:</p>
        <ul className="list-disc pl-5 space-y-2 mb-3" data-id="element-115">
          <li data-id="element-116">Acceso inmediato para descargar el PDF</li>
          <li data-id="element-117">Una copia del PDF enviada a tu correo electrónico</li>
          <li data-id="element-118">Acceso permanente al contenido adquirido</li>
        </ul>
      </section>

      <section className="mb-6" data-id="element-119">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-120">
          5. Garantía de Satisfacción (7 días)
        </h3>
        <p className="mb-3" data-id="element-121">
          Ofrecemos una garantía de satisfacción de 7 días. Si no estás
          satisfecha con el producto, puedes solicitar un reembolso completo
          dentro de los 7 días posteriores a la compra.
        </p>
        <p className="mb-3" data-id="element-122">
          Para solicitar un reembolso, simplemente envía un correo electrónico.
          No se requieren explicaciones ni justificaciones.
        </p>
      </section>

      <section className="mb-6" data-id="element-123">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-124">
          6. Propiedad Intelectual
        </h3>
        <p className="mb-3" data-id="element-125">
          Todo el contenido de "Transforma tu Vida: Un Nuevo Comienzo",
          incluyendo texto, diseño, gráficos y organización, está protegido por
          derechos de autor.
        </p>
        <p className="mb-3" data-id="element-126">
          <strong className="text-[#5C4A3A]" data-id="element-127">Está permitido:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-2 mb-3" data-id="element-128">
          <li data-id="element-129">Descargar y guardar el PDF para uso personal</li>
          <li data-id="element-130">Imprimir el contenido para uso personal</li>
          <li data-id="element-131">Leer y aplicar las enseñanzas en tu vida</li>
        </ul>
        <p className="mb-3" data-id="element-132">
          <strong className="text-[#5C4A3A]" data-id="element-133">No está permitido:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-2 mb-3" data-id="element-134">
          <li data-id="element-135">Compartir, distribuir o revender el PDF</li>
          <li data-id="element-136">Publicar el contenido en línea o en redes sociales</li>
          <li data-id="element-137">Modificar, adaptar o crear obras derivadas</li>
          <li data-id="element-138">Usar el contenido con fines comerciales</li>
        </ul>
      </section>

      <section className="mb-6" data-id="element-139">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-140">
          7. Limitación de Responsabilidad
        </h3>
        <p className="mb-3" data-id="element-141">
          Esta guía proporciona información y estrategias de desarrollo
          personal. Los resultados pueden variar según cada persona y su
          situación particular.
        </p>
        <p className="mb-3" data-id="element-142">
          No garantizamos resultados específicos. El uso de este material es
          bajo tu propia responsabilidad.
        </p>
      </section>

      <section className="mb-6" data-id="element-143">
        <h3 className="text-lg font-serif font-bold text-[#5C4A3A] mb-3" data-id="element-144">
          8. Modificaciones
        </h3>
        <p className="mb-3" data-id="element-145">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación.
        </p>
      </section>

      <div className="mt-8 p-4 bg-[#FBF8F3] rounded-xl border border-[#E8A87C]/20" data-id="element-146">
        <p className="text-sm text-[#5C4A3A]/70 italic" data-id="element-147">
          Al completar tu compra, confirmas que has leído, comprendido y
          aceptado estos Términos de Servicio.
        </p>
      </div>
    </div>;
}